import closeErrorMessageFactory from '../../../controllers/onboarding/close-error-message';

export default function serviceNotAvailableController() {
	var $ctrl = this;
	$ctrl.serviceNotAvailable = true;
	$ctrl.closeErrorMessage = closeErrorMessageFactory($ctrl);
}
